import { Component, OnInit } from '@angular/core';
import { LugaresService, MiembroFamilia } from 'src/app/servicios/lugares.service';
import { Location } from '@angular/common';
import { HeaderInfoService } from 'src/app/servicios/header-info.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/servicios/toast.service';

@Component({
  selector: 'app-detalle-miembro',
  templateUrl: './detalle-miembro.component.html',
  styleUrls: ['./detalle-miembro.component.scss']
})
export class DetalleMiembroComponent implements OnInit {

  miembro: MiembroFamilia;
  cargando: boolean = false;
  esCitofonia: boolean;
  currentFotoMiembro = null;
  idInmueble: string;
  idMiembro: string;

  constructor(
    private readonly location: Location,
    private headerInfoService: HeaderInfoService,
    private lugaresService: LugaresService,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.headerInfoService.cambiarTituloTarjeta("Información residente");
    this.esCitofonia = this.location.path().includes("citofonia");
    this.idInmueble = this.route.snapshot.paramMap.get("idApartamento");
    this.idMiembro = this.route.snapshot.paramMap.get("idMiembro");
    
    this.lugaresService.traerGrupoFamiliar(this.idInmueble).subscribe(res => {
      this.miembro = res.data.grupofamiliar.find(miembro => miembro.id === parseInt(this.idMiembro));

      if(this.miembro) 
        this.headerInfoService.cambiarTituloTarjeta(`Información ${this.miembro.name}`);
      else {
        this.miembro = null;
        this.toastService.mostrarToast("No se encontra este miembro en el grupo familiar");
      }
    }, err => {
      this.toastService.mostrarToast(err.error.data.message);
      this.miembro = null;
    });
  }
}
